/* Presentation for Fellino's existing Shopify Forms newsletter; submission stays native. */
(() => {
  const selector = 'shopify-forms-embed#app-embed-container-1205382';
  const css = `
    #app-embed {
      --forms-heading-font: normal 700 30px Arial, sans-serif;
      --forms-heading-font-size: 30px;
      --heading-font-size: 30px;
      --forms-body-font: normal 400 15px Arial, sans-serif;
      --forms-base-font-size: 15px;
      --container-border-radius: 16px;
      --form-field-border-radius: 8px;
      --button-border-radius: 8px;
      --container-text-alignment: left;
      --disclaimer-padding: 0;
    }
    #app-embed [role="dialog"][aria-label][data-sizing="form-wrapper"] { --col-size: 360px; max-height: calc(100dvh - 32px); }
    #app-embed h2 { line-height: 1.12; letter-spacing: -.035em; }
    #app-embed [style*="Newsletter_Logo.png"] {
      background-image: url("https://cdn.shopify.com/s/files/1/0936/5484/3766/files/Newsletter_Logo.png?v=1790711877&width=720") !important;
      background-position: center 52%;
    }
    #app-embed [data-testid="field-email"] { box-sizing: border-box; font-size: 16px; height: 52px; min-height: 52px; }
    #app-embed [data-testid="btn-form-submit"] { box-sizing: border-box; display: flex; align-items: center; justify-content: center; text-align: center; min-height: 52px; font-size: 15px; font-weight: 700; line-height: 1.3; }
    #app-embed [class*="_formDisclaimer_"] { font-size: 12px; line-height: 1.5; }
    #app-embed [class*="_formContainerCloseButtonPosition_"] { top: 10px; right: 10px; }
    #app-embed [class*="_formCloseButton_"] { width: 44px; height: 44px; }
    @media (max-width: 768px) {
      #app-embed { --forms-heading-font: normal 700 28px Arial, sans-serif; --forms-heading-font-size: 28px; --heading-font-size: 28px; --spacing-size-y: 26px; --spacing-size-x: 24px; }
      #app-embed [role="dialog"][aria-label][data-sizing="form-wrapper"] { grid-template-rows: 144px min-content; min-width: 0; width: min(390px, calc(100vw - 32px)); max-width: calc(100vw - 32px); }
      #app-embed [style*="Newsletter_Logo.png"] { background-position: center 48%; }
    }
    @media (max-height: 600px) and (max-width: 768px) {
      #app-embed [role="dialog"][aria-label][data-sizing="form-wrapper"] { grid-template-rows: 90px min-content; }
    }
    @media (prefers-reduced-motion: reduce) { #app-embed *, #app-embed *::before { animation: none !important; transition: none !important; } }
  `;
  const attach = () => {
    const host = document.querySelector(selector);
    if (!host?.shadowRoot || host.dataset.fellinoNewsletter) return;
    host.dataset.fellinoNewsletter = 'true';
    const style = document.createElement('style');
    style.textContent = css;
    host.shadowRoot.append(style);
  };
  customElements.whenDefined('shopify-forms-embed').then(() => {
    attach();
    new MutationObserver(attach).observe(document.body, { childList: true });
  });
})();
